import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react';
import axiosaim from '../../../api/axiosaim';
import LeaveCredits from './LeaveCredits';
import Years from './Years';
import Employee from './Employee';
import { useLeaveData } from '../../../hooks/leaveData';

const CreditOutlet = ({ departmentslug }) => {
    const { leaveData } = useLeaveData();

    const aimtoken = sessionStorage.getItem('aimtoken') || '';

    const { data: employees, isLoading: isLoadingEmployees } = useQuery({
        queryKey: ['departmentEmployees', {departmentslug}],
        queryFn: async () => {
            const res = await axiosaim.get(`getuserlistsperdepartment?d=${departmentslug}`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!departmentslug && !!aimtoken,
    });

    return (
        <div className='columns'>
            <div className='column'>
                <Years />
            </div>

            {
                leaveData.year && (
                    <div className='column'>
                        <Employee employees={employees} isLoadingEmployees={isLoadingEmployees} />
                    </div>
                )
            }

            {
                leaveData.employee && (
                    <div className='column'>
                        <LeaveCredits />
                    </div>
                )
            }
            
        </div>
    )
}

export default CreditOutlet;